export default "__VITE_ASSET__DH$aVQyo__"